import { render, staticRenderFns } from "./ModalTip.vue?vue&type=template&id=21b85c64&scoped=true"
import script from "./ModalTip.vue?vue&type=script&lang=js"
export * from "./ModalTip.vue?vue&type=script&lang=js"
import style0 from "./ModalTip.vue?vue&type=style&index=0&id=21b85c64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b85c64",
  null
  
)

export default component.exports